<template>
    <div class="container-fluid" v-loading="loading">
        <slot :data="slotData"></slot>
    </div>
</template>

<script>
    import Mixins from "./../common/AssessmentMixins";
    export default {
        mounted() {
            this.currentPage = this.initPage;
            this.getContents();
            prolitEvents.$on('Navigation:next', ev => this.nextPage());
            prolitEvents.$on('Navigation:previous', ev => this.previousPage());
            prolitEvents.$on('Navigation:finish', ev => this.finish());
            prolitEvents.$on('QuestionAnswered',ev=> this.currentAnswered++);
        },
        mixins:[Mixins],

        data() {
            return {
                currentPage: 1,
                contentPage: {
                    title: '',
                    body: '',
                    image: ''
                },
                loading: false,
                questions: null,

            }
        },
        computed: {
            slotData() {
                return {
                    currentPage: this.currentPage,
                    contentPage: this.contentPage,
                    loading: this.loading,
                    questions: this.questions,
                    nextPageAvailable: this.enableNextPage,
                    currentAnswered: this.currentAnswered,
                    totalAssessmentQuestions : this.totalAssessmentQuestions

                }
            },
            routes() {
                return {
                    assessments: window.App.routes.web.assessment,
                    pages: window.App.routes.api.interest_pages,
                    questions: window.App.routes.api.interest_questions,
                    store: window.App.routes.api.interest_answers_store,
                    update: window.App.routes.api.interest_answers_update,
                    counter: window.App.routes.api.assessments_count.replace("SLUG",this.assessment.slug),
                    finish: window.App.routes.api.assessments_finish.replace("SLUG",this.assessment.slug),
                };
            },
            enableNextPage(){
                return  this.currentAnswered >= (this.currentPage - 4) * 10;
            }
        },
        methods: {
            getQuestions(page) {
                this.loading = true;
                axios.get(this.routes.questions.replace('NUM', 'page='+page)).then(response => {
                    this.loading = false;
                    this.questions = response.data.data;
                }).catch(e => {
                    console.log(e);
                    this.loading = false;
                });

            },
            getPageContent(page) {

                this.loading = true;
                axios.get(this.routes.pages.replace('NUM', page)).then(response => {
                    this.loading = false;
                    this.contentPage.title = response.data.data.page.title;
                    this.contentPage.body = response.data.data.page.body;
                    this.contentPage.image = response.data.data.page.logo;
                }).catch(e => {
                    console.log(e);
                    this.loading = false;
                });
            },
            nextPage() {
                if(this.verifyQuestionsAnswered()) {
                    this.currentPage++;
                    this.getContents();
                }
            },
            previousPage() {
                this.currentPage--;
                this.getContents();
            },
            verifyQuestionsAnswered(){
                if(this.currentAnswered>=((this.currentPage-4)*10)){
                    return true;
                }
                prolitEvents.$emit('ShowNotAnswered');
                return false;
            },
            getContents(){
                this.currentPage > 4 ? this.getPageContent(5) : this.getPageContent(this.currentPage);
                this.currentPage > 4 ? this.getQuestions(this.currentPage - 4) : null;
                this.setUrlPageParameter(this.currentPage);
                this.getCounterData(); //current answered questions count
            },
            finish(){
                if(this.verifyQuestionsAnswered()){
                    this.loading = true;
                    axios.post(this.routes.finish).then(response=>{
                        window.location = this.routes.assessments;
                    }).catch(e=>{
                        this.loading = false;
                        console.log(e)
                    });
                }
            },

        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/assessments/interests/InterestsPage.vue